// extracted by mini-css-extract-plugin
export default {"agentLeg":"ccf-agent-leg_agentLeg__518SJ","agentLegLyra":"ccf-agent-leg_agentLegLyra__yNTHW"};